import React from 'react'
import OpportunityCardSkeleton from './OpportunityCardSkeleton'

interface OpportunityGridSkeletonProps {
  cardCount?: number
}

const OpportunityGridSkeleton = ({ cardCount = 6 }: OpportunityGridSkeletonProps) => {
  return (
    <div className="flex flex-col">
      <div className="p-8 pt-0">
        <div className="grid grid-cols-[repeat(auto-fit,minmax(260px,1fr))] gap-5">
          {Array.from({ length: cardCount }).map((_, index) => (
            <OpportunityCardSkeleton key={index} />
          ))}
        </div>
      </div>
    </div>
  )
}

export default OpportunityGridSkeleton
